import { separate } from '@packages/strings';
import { Map } from 'immutable';
import castArray from 'lodash/castArray';

export class GetterSetter {
    /**
     * Data collection
     * @type {Map<string, any>}
     * @protected
     */
    __data: Map<string, any> = Map<string, any>();

    protected getSeparator = (): any => '.';

    public getData(): Map<string, any> {
        return this.__data;
    }

    private _genKey(key: string): string[] {
        return castArray(separate(key, this.getSeparator()));
    }

    /**
     * Data get method
     * @param key
     * @returns {any}
     */
    protected _get<T = any>(key: string): T {
        return this.__data.getIn(this._genKey(key));
    }

    /**
     * Data set method
     * @param key
     * @param value
     */
    protected _set(key: string, value: any): this {
        this.__data = this.__data.setIn(this._genKey(key), value);
        return this;
    }

    /**
     * Unset data
     * @param key
     * @protected
     */
    protected _unset(key: string): this {
        this.__data = this.__data.removeIn(this._genKey(key)) || this.__data;
        return this;
    }

    /**
     * Data has method
     * @param key
     * @returns {boolean}
     */
    protected _has(key: string): boolean {
        return this.__data.hasIn(this._genKey(key));
    }

    /**
     *
     * @param key
     * @returns {T}
     */
    public get<T = any>(key: string): T {
        return this._get<T>(key);
    }

    /**
     *
     * @param key
     * @param value
     * @returns {T}
     */
    public set(key: string, value: any): this {
        return this._set(key, value);
    }

    /**
     *
     * @param key
     * @returns {T}
     */
    public unset(key: string): this {
        return this._unset(key);
    }

    /**
     *
     * @param key
     * @returns {boolean}
     */
    public has(key: string): boolean {
        return this._has(key);
    }
}
